var React = require('react');

function PhotoLibraryInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41.25 30V7.5C41.25 5.4375 39.5625 3.75 37.5 3.75H15C12.9375 3.75 11.25 5.4375 11.25 7.5V30C11.25 32.0625 12.9375 33.75 15 33.75H37.5C39.5625 33.75 41.25 32.0625 41.25 30ZM20.625 22.5L24.4312 27.5812L30 20.625L37.5 30H15L20.625 22.5ZM3.75 11.25V37.5C3.75 39.5625 5.4375 41.25 7.5 41.25H33.75V37.5H7.5V11.25H3.75Z","fill":"white"}));
}

PhotoLibraryInline.defaultProps = {"width":"45","height":"45","viewBox":"0 0 45 45","fill":"none"};

module.exports = PhotoLibraryInline;

PhotoLibraryInline.default = PhotoLibraryInline;
